<template>
  <div class="funnel-responsive-modal p-3">
    <button class="btn text-secondary close" @click="close">
      <i class="icon-x" />
    </button>
    <strong>Próxima etapa</strong>
    <div>
      <span class="small text-secondary">{{
        previous ? "Etapa anterior: " + previous.name : ""
      }}</span>
    </div>
    <hr />
    <button-switch
      v-model="option"
      :options="modalOptions"
      v-if="!funnelToEdit && existingFunnels.length"
    />

    <form v-if="option == 1" @submit.prevent="submit">
      <form-group
        v-model="form.name"
        class="mt-5"
        label="Nome da etapa"
        placeholder="Ex: Upsell"
        :errors="errors.name"
        id="name"
      />
      <div class="d-flex justify-content-end">
        <small
          class="text-secondary"
          :class="{
            'text-danger': form.name && form.name.length > 200
          }"
        >
          {{ `${form.name ? form.name.length : 0}/200` }}
        </small>
      </div>
      <div class="d-flex justify-content-between align-items-center mt-5">
        <strong>Esta é uma página de obrigado</strong>
        <form-group isSwitch v-model="form.is_end" id="is-end" />
      </div>
      <div v-if="!form.is_end">
        <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
          <form-group
            class="mt-3"
            select
            v-model="form.product_id"
            label="Nome do produto"
            placeholder="Selecionar produto..."
            :options="products"
            :errors="errors.product_id"
            id="product-select"
          />
        </action-dispatcher>
        <action-dispatcher
          v-if="form.product_id"
          :key="`${form.product_id}`"
          :action="isSignature ? 'plan/get' : 'offer/get'"
          :parameters="{ product_id: form.product_id }"
        >
          <form-group
            v-if="isSignature"
            select
            v-model="form.plan_id"
            label="Plano"
            placeholder="Selecionar o plano..."
            :options="plans"
            id="offer-select"
            :errors="errors.plan_id"
          />
          <form-group
            v-else
            select
            v-model="form.offer_id"
            label="Oferta"
            placeholder="Selecionar oferta..."
            :options="offers"
            :errors="errors.offer_id"
            id="offer-select"
          />
        </action-dispatcher>
        <hr />
        <form-group
          v-model="form.cta_text"
          label="Texto para ação de efetuar a compra"
          placeholder="Ex: Quero aproveitar a oferta"
          id="cta-text"
        />
        <form-group
          v-model="form.ctb_text"
          label='Texto para opção "não"'
          placeholder="Ex: Não quero"
          id="ctb-text"
        />
        <hr />
      </div>
      <form-group
        :errors="errors.url_cta"
        v-model="form.url_cta"
        label="URL da página da oferta"
        placeholder="Ex: http://meusite.com/oferta"
        id="url-cta"
      />
      <div class="row justify-content-between mx-0 mt-6">
        <button
          type="button"
          class="btn btn-outline-secondary col-5"
          @click="close"
        >
          Cancelar
        </button>
        <button
          class="btn col-5"
          :class="isValid ? 'btn-success' : 'btn-secondary'"
          :disabled="!isValid"
        >
          <loading :show="loading">
            Concluir
          </loading>
        </button>
      </div>
    </form>

    <form v-else-if="option == 2" @submit.prevent="submitExisting">
      <b-form-radio-group class="mt-6">
        <div
          v-for="(funnel, index) in existingFunnels"
          :key="index"
          class="existing-step d-flex align-items-center pl-5 py-3 mt-3"
        >
          <b-form-radio v-model="step" :value="funnel.id" />
          <div v-if="funnel.product" class="px-3">
            <img
              class="product-sm-picture"
              v-if="funnel.product.picture"
              :src="funnel.product.picture"
            />
            <img
              v-else
              class="product-sm-picture"
              :src="
                require('@/assets/images/product/blitz-product-placeholder.png')
              "
            />
          </div>
          <div>
            <div class="align-bottom font-weight-bold">
              {{ funnel.name }}
            </div>
            <div class="align-top small">
              {{ funnel.is_end ? "Página de obrigado" : funnel.product.name }}
            </div>
          </div>
        </div>
      </b-form-radio-group>
      <div class="row justify-content-between mx-0 mt-6">
        <button
          type="button"
          class="btn btn-outline-secondary col-5"
          @click="close"
        >
          Cancelar
        </button>
        <button
          class="btn col-5"
          :class="step ? 'btn-success' : 'btn-secondary'"
          :disabled="!step"
        >
          <loading :show="loading">
            Concluir
          </loading>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { clearObject, formFields } from "@/functions/helpers";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    funnelToEdit: {
      type: Object,
      default: null
    },
    previous: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      step: null,
      previousFunnel: this.previous
        ? {
            ...this.previous,
            product_id: get(this.previous, "product.id"),
            offer_id: get(this.previous, "offer.id"),
            plan_id: get(this.previous, "plan.id"),
            action_yes_id: get(this.previous, "action_yes.id"),
            action_no_id: get(this.previous, "action_no.id")
          }
        : null,
      newFunnelId: null,
      option: 1,
      ...formFields(
        [
          "name",
          "parent",
          "is_active",
          "product_id",
          "offer_id",
          "plan_id",
          "cta_text",
          "ctb_text",
          "url_cta",
          "is_end",
          "method_payment"
        ],
        {
          is_end: false,
          is_active: true,
          method_payment: "card",
          ...(this.funnelToEdit ? this.funnelToEdit : {}),
          product_id: get(this.funnelToEdit, "product.id"),
          offer_id: get(this.funnelToEdit, "offer.id"),
          plan_id: get(this.funnelToEdit, "plan.id")
        }
      )
    };
  },
  watch: {
    "form.offer_id": function(val) {
      if (val) {
        this.form.plan_id = "";
      }
    },
    "form.plan": function(val) {
      if (val) {
        this.form.offer_id = "";
      }
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("funnel", ["funnels"]),
    ...mapState("offer", ["offers"]),
    ...mapState("plan", ["plans"]),
    isValid() {
      return (
        this.form.name &&
        this.form.name.length <= 200 &&
        (this.form.is_end ||
          (this.form.product_id && (this.form.offer_id || this.form.plan_id)))
      );
    },
    selectedProduct() {
      return this.products.find(p => p.id === this.form.product_id);
    },
    isSignature() {
      return get(this.selectedProduct, "type_product") === "signature";
    },
    modalOptions() {
      let options = [{ title: "Nova etapa", value: 1 }];
      if (this.action) {
        options.push({ title: "Etapa existente", value: 2 });
      }
      return options;
    },
    existingFunnels() {
      return this.funnels.filter(
        f =>
          f.id != get(this.form, "id") &&
          f.id != get(this.previous, "id") &&
          f.parent
      );
    }
  },
  methods: {
    submit() {
      if (this.previousFunnel) {
        this.form.parent = this.previousFunnel.id;
      }
      let action = this.funnelToEdit ? "funnel/put" : "funnel/post";
      if (action == "funnel/post") {
        this.form.sort = this.funnels.length;
      } else {
        this.form.id = this.funnelToEdit.id;
      }
      if (this.isSignature) {
        delete this.form.offer_id;
      } else {
        delete this.form.plan_id;
      }
      this.loading = true;
      this.$store
        .dispatch(action, clearObject(this.form))
        .then(response => {
          this.newFunnelId = response.data.id;
          if (this.action == "yes") {
            this.$store.dispatch(
              "funnel/put",
              clearObject({
                ...this.previousFunnel,
                action_yes_id: this.newFunnelId
              })
            );
          } else if (this.action == "no") {
            this.$store.dispatch(
              "funnel/put",
              clearObject({
                ...this.previousFunnel,
                action_no_id: this.newFunnelId
              })
            );
          }
          this.$emit("refresh");
          this.close();
        })
        .catch(error => {
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitExisting() {
      let params = { ...this.previousFunnel };
      if (this.action == "yes") {
        params.action_yes_id = this.step;
      } else if (this.action == "no") {
        params.action_no_id = this.step;
      }
      this.loading = true;
      this.$store
        .dispatch("funnel/put", clearObject(params))
        .then(() => {
          this.close();
          this.$emit("refresh");
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.funnel-responsive-modal {
  .existing-step {
    display: flex;
    background-color: whitesmoke;
    border: 1px solid lightgrey;
    border-radius: 4px;
  }
  .close {
    top: 0;
    right: 10px;
  }

  button {
    i {
      font-size: 28px;
    }
  }
  .custom-control-inline {
    margin-right: 0;
  }
}
</style>
